<div [ngClass]="
   'clear-input paired-input container' + ' '
   + (!isInputValid ? 'invalid' + ' '  : '')">
  <i *ngIf="!searching" class="clear-icon header-action-icon"
     [ngClass]="optionsControl.value ? 'bhi-times' : 'bhi-search search-icon'"
     [attr.role]="optionsControl.value ? 'button' : null"
     [attr.aria-label]="optionsControl.value ? 'Clear field' : null"
     [attr.tabindex]="optionsControl.value ? '0' : '-1'"
     [matTooltip]="optionsControl.value ? 'Clear field' : ''"
     [matTooltipShowDelay]="500"
     matTooltipPosition="above"
     (click)="optionsControl.value && clearInput(optionInput, true)"
     (keydown.enter)="optionsControl.value && clearInput(optionInput, true)"
     (keydown.space)="$event.preventDefault(); optionsControl.value && clearInput(optionInput, true)"></i>
  <app-entity-picker
    [descriptorControl]="secondaryEntityControl"
    [entities]="entitiesOptions"
    [primaryEntity]="primaryEntity"
    [dataSourceType]="dataSourceType"
    (onToggle)="onEntitiesDropDownToggle($event)"
    [overlayPositioningConfig]="overlayPositioningConfig"
  ></app-entity-picker>
  <span class="divider">|</span>
  <input type="text" [placeholder]="placeholder" (click)="forceShowOptionsDropDown($event)"
         [matAutocomplete]="optionAuto"
         [formControl]="optionsControl" #optionInput [title]="titleTooltip"
         (keydown.escape)="onEscape($event, optionInput)">
  <span *ngIf="searching" class="input-loading-spinner spinner-border spinner-border-sm"></span>
</div>
<mat-autocomplete #optionAuto class="mat-paired-autocomplete-panel" [displayWith]="displayValue"
                  (optionSelected)="optionSelected($event)">
  <mat-option *ngFor="let optionItem of filteredOptions$ | async" [value]="optionItem.name">
    {{optionItem.label}} ({{optionItem.name}})
  </mat-option>
</mat-autocomplete>
